import { resourceActionTypes } from '@Actions/production/resourceActions';

const ResourceReducers = (state = { }, action) => {
  switch (action.type) {
  case resourceActionTypes.GET_RESOURCE.LOADING: {
    const { getResourceLoading } = action;
    return {
      ...state,
      getResourceLoading,
    };
  }
  case resourceActionTypes.GET_RESOURCE.SUCCESS: {
    const { resources, isDropdown } = action;
    if (isDropdown) {
      return {
        ...state,
        dropdownResources: resources,
      };
    }
    return {
      ...state,
      resources,
    };
  }
  case resourceActionTypes.GET_RESOURCE_BY_ID.LOADING: {
    const { getResourceByIdLoading } = action;
    return {
      ...state,
      getResourceByIdLoading,
    };
  }
  case resourceActionTypes.GET_RESOURCE_BY_ID.SUCCESS: {
    const { selectedResource } = action;
    return {
      ...state,
      selectedResource,
    };
  }
  case resourceActionTypes.CREATE_RESOURCE.LOADING: {
    const { createResourceLoading } = action;
    return {
      ...state,
      createResourceLoading,
    };
  }
  case resourceActionTypes.UPDATE_RESOURCE.LOADING: {
    const { updateResourceLoading } = action;
    return {
      ...state,
      updateResourceLoading,
    };
  }
  case resourceActionTypes.UPDATE_STATUS_RESOURCE.LOADING: {
    const { updateResourceStatusLoading } = action;
    return {
      ...state,
      updateResourceStatusLoading,
    };
  }
  case resourceActionTypes.DELETE_RESOURCE.LOADING: {
    const { deleteResourceLoading } = action;
    return {
      ...state,
      deleteResourceLoading,
    };
  }

  case resourceActionTypes.GET_RESOURCE_GROUP.LOADING: {
    const { getResourceGroupLoading } = action;
    return {
      ...state,
      getResourceGroupLoading,
    };
  }
  case resourceActionTypes.GET_RESOURCE_GROUP.SUCCESS: {
    const { resourcesGroup } = action;
    return {
      ...state,
      resourcesGroup,
    };
  }
  case resourceActionTypes.CREATE_RESOURCE_GROUP.LOADING: {
    const { createResourceGroupLoading } = action;
    return {
      ...state,
      createResourceGroupLoading,
    };
  }
  case resourceActionTypes.UPDATE_RESOURCE_GROUP.LOADING: {
    const { updateResourceGroupLoading } = action;
    return {
      ...state,
      updateResourceGroupLoading,
    };
  }
  case resourceActionTypes.DELETE_RESOURCE_GROUP.LOADING: {
    const { deleteResourceGroupLoading } = action;
    return {
      ...state,
      deleteResourceGroupLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default ResourceReducers;
